export const AURORA_MAX_TEMPERATURE_LIMIT = 60

export const AURORA_MIN_TEMPERATURE_LIMIT = 5
